import { createCustomerPortalSession as mintPortalSession } from "@repo/shared/api";

// The shared call, opened web's way. The contract stays in shared.
export const createCustomerPortalSession = async () => {
  const url = await mintPortalSession();
  if (url) window.location.href = url;
};
